import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import Feature from '../Feature';
import { GRACE_PERIOD_CANCELLATION_FEATURE } from '../featureList';

import GracePeriodCancellationIcon from './GracePeriodCancellationIcon';

const GracePeriodCancellationFeature = ({ collapsed, onCollapsedChange }) => {
  return (
    <Feature
      featureName={GRACE_PERIOD_CANCELLATION_FEATURE}
      collapsed={collapsed}
      onCollapsedChange={onCollapsedChange}
      renderBody={() =>
        trans('property_show.book_now_card.grace.period.cancellation.body')
      }
      renderIcon={() => <GracePeriodCancellationIcon />}
      headerKey="property_show.book_now_card.grace.period.cancellation.title"
    />
  );
};

GracePeriodCancellationFeature.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  onCollapsedChange: PropTypes.func.isRequired
};

export default GracePeriodCancellationFeature;
